<template>
  <div class="h-screen flex flex-col items-center relative overflow-hidden">
    <LogoSvg />
    <div
      class="flex justify-center items-center w-3/12 absolute top-3 left-1/2 -translate-x-1/2"
    >
      <img src="@/assets/logo-1.webp" alt="logo" />
    </div>
    <!-- Main Content -->
    <div
      class="px-4 p-1 flex flex-col justify-center bg-transparent shadow-md drop-shadow-2xl lg:p-2 rounded-md mb-36"
    >
      <div class="text-center">
        <div class="flex justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="#9d2890"
            class="h-24 w-24 animate-bounce"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
            />
          </svg>
        </div>
        <div class="mt-0 text-white text-lg font-bold">Payment Failed...</div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoSvg from "@/components/svg/LogoSvg.vue";
import { useAuthStore } from "@/stores/auth";
import { mapActions } from "pinia";
export default {
  components: {
    LogoSvg,
  },
  data() {
    return {
      successStatus: false,
      isMobile: false,
      showBottomSheet: false,
    };
  },
  methods: {
    ...mapActions(useAuthStore, ["checkStatus"]),
  },
};
</script>

<style scoped>
/* Your existing styles */
</style>

<style scoped></style>
